import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import React, { useEffect, useState } from "react";
import { createUser } from "../../api";
import { jwtDecode } from "jwt-decode";
import { getUsers, getPractice, sendPasswordResetEmail } from "../../api";
import { FaCheck, FaTimes } from "react-icons/fa";

function MyUserModal({onUserUpdate = () => {}, ...props}) {
  const [pracName, setPracName] = useState([]);
  const [closeAlert, setCloseAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedPractices, setSelectedPractices] = useState([]);
  const [user, setUser] = useState({
    email: "",
    firstName: "",
    lastName: "",
    hpcsa: "",
    occupation: "",
    phoneNumber: "",
    role: [],
    practice: [],
    password: "",
  });

  useEffect(() => {
    async function getPracticeId() {
      const token = sessionStorage.getItem("user");
      if (token) {
        const decoded = jwtDecode(token);
        const allUsers = await getUsers();
        const findUser = allUsers.find((user) => user._id === decoded._id);
        const allPracs = await getPractice();
        const findPracName = allPracs.filter((prac) =>
          findUser.practice.includes(prac.practiceNumber)
        );
        setPracName(findPracName);
      }
    }
    getPracticeId();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    const isValidEmailFormat = /\S+@\S+\.\S+/.test(user.email);


    if (!user.email || !isValidEmailFormat) newErrors.email = "Enter a valid email.";
    if (!user.firstName) newErrors.firstName = "First name is required.";
    if (!user.lastName) newErrors.lastName = "Last name is required.";
    if (!user.occupation) newErrors.occupation = "Occupation is required.";
    if (!user.phoneNumber || !/^\d{3}-\d{3}-\d{4}$/.test(user.phoneNumber))
      newErrors.phoneNumber = "Enter a valid phone number (xxx-xxx-xxxx).";
    if (!selectedRoles.length) newErrors.role = "At least one role must be selected.";
    if (!selectedPractices.length) newErrors.practice = "At least one practice must be selected.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await createUser({ ...user, role: selectedRoles, practice: selectedPractices });
      if (response.status === 200) {
        setSuccessAlert(true);
        sendPasswordResetEmail(user.email)
                .then(() => console.log("✅ Password reset requested for:", user.email))
                .catch((error) => {
                  console.error("⛔ Error during password reset request:", error);

                });
        setTimeout(() => {
          setSuccessAlert(false);
          props.onHide();
          onUserUpdate();
        }, 3000);
      }
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNumber") {
      const digits = value.replace(/\D/g, "");
      const formatted = digits.slice(0, 10).replace(/(\d{3})(\d{3})(\d{1,4})/, "$1-$2-$3");
      setUser((prev) => ({ ...prev, [name]: formatted }));
    } else {
      setUser((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleRoleChange = (role) => {
    setSelectedRoles((prev) =>
      prev.includes(role) ? prev.filter((r) => r !== role) : [...prev, role]
    );
  };

  const handlePracticeChange = (practiceNumber) => {
    setSelectedPractices((prev) =>
      prev.includes(practiceNumber)
        ? prev.filter((p) => p !== practiceNumber)
        : [...prev, practiceNumber]
    );
  };

  function handleClose ()  {
    setCloseAlert(true); // Show confirmation alert
  };

const handleCancelNo = () => {
    setCloseAlert(false); // Hide alert and keep modal open
  };

const handleCancelYes = async () => {
    setCloseAlert(false);
    setUser({
      email: "",
      firstName: "",
      lastName: "",
      hpcsa: "",
      occupation: "",
      phoneNumber: "",
      role: [],
      practice: [],
      password: "",
    });
    setSelectedPractices([]);
    setSelectedRoles([]);
    props.onHide();
    // Close the modal after successful operation
};

  return (
    <Modal {...props} onHide={handleClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton={!closeAlert && !successAlert }>
      <div className="w-100">
        <Modal.Title id="contained-modal-title-vcenter" className="text-primary">
          Add Team Member
          
        </Modal.Title>
        </div>
      </Modal.Header>
      {closeAlert && (
            <Alert variant="info" className="w-100 d-flex align-items-center justify-content-between fs-6 fw-normal"  onClose={() => setCloseAlert(false)}>
            <span>Are you sure you want to close? The entered data will be removed.</span>
            <div className="ms-auto d-flex">
            <Button variant="outline-primary" className="btn btn-outline-primary me-1"  onClick={handleCancelYes}>
                <FaCheck />
                </Button>
                <Button variant="outline-secondary" className="btn btn-outline-secondary me-1"  onClick={handleCancelNo}>
                <FaTimes />
                </Button>
                </div>
            </Alert> 
          )}
          {successAlert && (
            <Alert variant="success" className="w-100 d-flex align-items-center justify-content-between fs-6 fw-normal"  onClose={() => setCloseAlert(false)}>
            <span>The user was added successfully. They will receive an email to select their password.</span>
            </Alert> 
          )}
      <Modal.Body>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                required
                name="email"
                isInvalid={!!errors.email}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                required
                placeholder="First Name"
                name="firstName"
                isInvalid={!!errors.firstName}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">{errors.firstName}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                required
                placeholder="Last Name"
                name="lastName"
                isInvalid={!!errors.lastName}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">{errors.lastName}</Form.Control.Feedback>
            </Form.Group>
       

          <Form.Group as={Col} controlId="hpcsa">
              <Form.Label>HPCSA #</Form.Label>
              <Form.Control
                required
                placeholder="hpcsa"
                name="hpcsa"
                onChange={handleChange}
              />
             
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formGridOccupation">
              <Form.Label>Occupation</Form.Label>
              <Form.Select
                required
                name="occupation"
                isInvalid={!!errors.occupation}
                onChange={handleChange}
              >
                <option>Choose...</option>
                <option>Administration</option>
                <option>Doctor</option>
                <option>Finance</option>
                <option>Nurse</option>
                <option>Occupational Therapist</option>
                <option>Podiatrist</option>
                <option>Physio Therapist</option>
                <option>Psychologist</option>
                <option>Speech Therapist</option>
                <option>Reception</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">{errors.occupation}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} controlId="phoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                placeholder="xxx-xxx-xxxx"
                name="phoneNumber"
                value={user.phoneNumber}
                isInvalid={!!errors.phoneNumber}
                onChange={handleChange}
              />
              <Form.Control.Feedback type="invalid">{errors.phoneNumber}</Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="roleCheckboxes">
              <Form.Label>Roles</Form.Label>
              <div>
                {["Administration", "Practitioner", "Finance", "SuperAdmin"].map((role) => (
                  <Form.Check
                    key={role}
                    type="checkbox"
                    label={role}
                    checked={selectedRoles.includes(role)}
                    onChange={() => handleRoleChange(role)}
                  />
                ))}
              </div>
              {errors.role && <div className="text-danger">{errors.role}</div>}
            </Form.Group>

            <Form.Group as={Col} controlId="practiceCheckboxes">
              <Form.Label>Practices</Form.Label>
              <div>
                {pracName.map((prac) => (
                  <Form.Check
                    key={prac.practiceNumber}
                    type="checkbox"
                    label={prac.practiceName}
                    checked={selectedPractices.includes(prac.practiceNumber)}
                    onChange={() => handlePracticeChange(prac.practiceNumber)}
                  />
                ))}
              </div>
              {errors.practice && <div className="text-danger">{errors.practice}</div>}
            </Form.Group>
          </Row>

          <div className="d-flex justify-content-center align-items-center">
          <Button
            variant="primary"
            className="px-5 py-2" // Adjust padding to make it longer
            type="submit"
          >
            Submit
          </Button>
        </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export function AddUser({ onUserUpdate }) {
  const [userModalShow, setUserModalShow] = useState(false);

  return (
    <div>
      <Button variant="primary" className="me-2 w-100" onClick={() => setUserModalShow(true)}>
        Add User
      </Button>
      <MyUserModal show={userModalShow} onHide={() => setUserModalShow(false)} onUserUpdate={onUserUpdate} />
    </div>
  );
}
